import CONFIG from '@config';
import algoliasearch from 'algoliasearch';

export default algoliasearch(CONFIG.algolia.app_id, CONFIG.algolia.search_key);
